/**
 * HeaderCenter component.
 * @module components/Header/HeaderCenter
 * Customizations
 * - Logo href is to mainsite on the search site
 */

import React from 'react';
import { UniversalLink } from '@plone/volto/components';
import { useSelector } from 'react-redux';
import { Header, HeaderContent, HeaderRightZone } from 'design-react-kit';
import { flattenToAppURL } from '@plone/volto/helpers';
import {
  Logo,
  SocialHeader,
  HeaderSearch,
  BrandText,
} from 'design-comuni-plone-theme/components/ItaliaTheme';

const HeaderCenter = () => {
  const subsite = useSelector((state) => state.subsite?.data);

  let logoSubsite = subsite?.subsite_logo && (
    <figure className="icon">
      <img
        src={flattenToAppURL(subsite.subsite_logo.scales?.mini?.download)}
        alt="Logo"
      />
    </figure>
  );

  const isSearchSite =
    (__CLIENT__ && window.env.RAZZLE_SOLR_SEARCH_SITE) ||
    process.env.RAZZLE_SOLR_SEARCH_SITE ||
    false;
  let mainSiteUrl =
    (__CLIENT__ && window.env.RAZZLE_MAIN_SITE_URL) ||
    process.env.RAZZLE_MAIN_SITE_URL ||
    '';

  const href =
    isSearchSite && mainSiteUrl
      ? mainSiteUrl
      : subsite?.['@id']
      ? flattenToAppURL(subsite['@id'])
      : '/';

  return (
    <Header small={false} theme="" type="center">
      <HeaderContent>
        <div className="it-brand-wrapper">
          <UniversalLink href={href}>
            {subsite?.subsite_logo ? logoSubsite : <Logo />}
            <BrandText subsite={subsite} />
          </UniversalLink>
        </div>
        <HeaderRightZone>
          <SocialHeader />
          <HeaderSearch />
        </HeaderRightZone>
      </HeaderContent>
    </Header>
  );
};

export default HeaderCenter;
